export const SET_COLOR_PICKER = 'SET_COLOR_PICKER'

const initialState = {
  colorPicker: null,
}

export default function (
  state = {
    ...initialState,
  },
  action = {}
) {
  switch (action.type) {
    case SET_COLOR_PICKER:
      return {
        ...state,
        colorPicker: action.data,
      }
    default:
      return state
  }
}
